import { Navigate } from 'react-router-dom';

/** Phase 5.1: legacy route → canonical Scheduling hub (queue tab). */
export default function ScheduledPosts() {
  return <Navigate to="/scheduling?tab=queue" replace />;
}
